import React from 'react';
import ProtectedRoute from './ProtectedRoute';
import PermissionBasedRoute from './PermissionBasedRoute';
import { SpotlightTourProvider } from '../../context/SpotlightTourContext';

interface AuthenticatedRouteGuardProps {
  children: React.ReactNode;
}

/**
 * Encapsula rotas autenticadas do tenant: auth → tour → permissões IAM.
 */
const AuthenticatedRouteGuard: React.FC<AuthenticatedRouteGuardProps> = ({ children }) => {
  return (
    <ProtectedRoute>
      <SpotlightTourProvider>
        <PermissionBasedRoute>{children}</PermissionBasedRoute>
      </SpotlightTourProvider>
    </ProtectedRoute>
  );
};

export default AuthenticatedRouteGuard;
